<template>
  <div class="quotation-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <!-- <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item> -->
            <el-form-item>
              <el-button icon="el-icon-refresh" @click="Search">刷新</el-button>
            </el-form-item>
            <el-form-item v-if="!loading && total == 0" style="float: right; position: relative; z-index: 999;">
              <el-button type="primary" @click="addQuotation" icon="el-icon-plus">添加报价书版本</el-button>
            </el-form-item>
          </el-form>

          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table :data="tableData" stripe style="width: 100%">
                  <el-table-column label="报价书名称" prop="name" align="center" min-width="160"
                    show-overflow-tooltip></el-table-column>
                  <el-table-column label="版本" prop="version" align="center" width="100"></el-table-column>
                  <el-table-column label="封面图" align="center" prop="cover" width="140">
                    <template #default="scope">
                      <el-image v-if="scope.row.cover" style="width: 50px; max-height: 50px; cursor: pointer;"
                        :src="scope.row.cover" fit="cover" :preview-src-list="[scope.row.cover]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="更改记录图" align="center" prop="change" width="140">
                    <template #default="scope">
                      <el-image v-if="scope.row.change" style="width: 50px; max-height: 50px; cursor: pointer;"
                        :src="scope.row.change" fit="cover" :preview-src-list="[scope.row.change]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="目录图" align="center" prop="catalogue" width="140">
                    <template #default="scope">
                      <el-image v-if="scope.row.catalogue" style="width: 50px; max-height: 50px; cursor: pointer;"
                        :src="scope.row.catalogue" fit="cover" :preview-src-list="[scope.row.catalogue]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="其他说明图" align="center" prop="explain" width="140">
                    <template #default="scope">
                      <el-image v-if="scope.row.explain" style="width: 50px; max-height: 50px; cursor: pointer;"
                        :src="scope.row.explain" fit="cover" :preview-src-list="[scope.row.explain]">
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" prop="remark" align="center" min-width="160"
                    show-overflow-tooltip></el-table-column>
                  <el-table-column label="创建时间" prop="createTime" align="center" width="160"></el-table-column>
                  <el-table-column label="更新时间" prop="updateTime" align="center" width="160"></el-table-column>
                  <el-table-column width="160" align="center" fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" icon="el-icon-edit" @click="editQuotation(scope.row)"
                        size="mini">编辑</el-button>
                      <el-button type="text" icon="el-icon-set-up" @click="uploadQuotation(scope.row)"
                        size="mini">上传报价书</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination v-if="total>0" background @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50, 100]"
                  :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog :title="editTitle" :visible.sync="editVisible" width="700px" top="10vh" destroy-on-close lock-scroll
      append-to-body>
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="100px"
        size="small">
        <el-form-item label="报价书名称" prop="name">
          <el-input v-model="editForm.name" maxlength="50" placeholder="请输入报价书名称" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="报价书版本" prop="version">
          <el-input v-model="editForm.version" maxlength="20" placeholder="请输入报价书版本" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="报价书封面" prop="cover">
          <MultiImg key="cover" v-model="editForm.cover" :limit="1"></MultiImg>
        </el-form-item>
        <el-form-item label="更改记录图片" prop="change">
          <MultiImg key="change" v-model="editForm.change" :limit="1"></MultiImg>
        </el-form-item>
        <el-form-item label="目录图片" prop="catalogue">
          <MultiImg key="catalogue" v-model="editForm.catalogue" :limit="1"></MultiImg>
        </el-form-item>
        <el-form-item label="其他说明图片" prop="explain">
          <MultiImg key="explain" v-model="editForm.explain" :limit="1"></MultiImg>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="editForm.remark"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="submit('editForm')">立即提交</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getOfferBookList,
    addOrEditOfferBook,
    delOfferBook
  } from '@/api/quotation'

  import MultiImg from './components/MultiImg'

  export default {
    name: 'quotation',
    computed: {
      user: getUser
    },
    components: {
      MultiImg
    },
    data() {
      return {
        searchForm: {
          search: ''
        },
        fullscreenLoading: false,

        loading: false,
        tableData: [],
        currentPage: 1,
        pageSize: 20,
        total: 0,

        editTitle: '添加报价书新版本',
        editVisible: false,
        editForm: {
          id: '',
          name: '',
        },
        editRules: {
          name: [{
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }],
          version: [{
            required: true,
            message: '请输入版本',
            trigger: 'blur'
          }],
        },
        editloading: false
      }
    },
    created() {
      this.getData()
    },
    methods: {
      Search() {
        this.currentPage = 1
        this.getData()
      },

      getData() {
        this.loading = true
        const data = {
          search: this.searchForm.search,
          page: this.currentPage,
          limit: this.pageSize,
          userId: this.user.dUserid,
          groupId: this.user.dGroupid,
        }
        getOfferBookList(data).then(response => {
          this.loading = false
          this.tableData = response.data || []
          this.total = response.total
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getData()
      },

      addQuotation() {
        this.editTitle = '添加报价书新版本'
        this.editVisible = true

        this.editForm = {}
      },
      editQuotation(row) {
        this.editTitle = '编辑报价书版本'
        this.editVisible = true
        this.editForm = {
          id: row.id,
          name: row.name,
          version: row.version,
          remark: row.remark,
          cover: row.cover ? row.cover.split(',') : [],
          change: row.change ? row.change.split(',') : [],
          catalogue: row.catalogue ? row.catalogue.split(',') : [],
          explain: row.explain ? row.explain.split(',') : [],
        }
      },

      uploadQuotation(row) {
        this.$router.push({
          path: '/work/offer-book/edit/' + row.id
        });
      },

      cancel() {
        this.editVisible = false
      },

      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.editloading) return;
            this.editloading = true
            const data = {
              userId: this.user.dUserid,
              groupId: this.user.dGroupid,
              id: this.editForm.id,
              name: this.editForm.name,
              version: this.editForm.version,
              remark: this.editForm.remark,
              cover: Array.isArray(this.editForm.cover) ? this.editForm.cover.join(',') : (this.editForm.cover || ''),
              change: Array.isArray(this.editForm.change) ? this.editForm.change.join(',') : (this.editForm.change || ''),
              catalogue: Array.isArray(this.editForm.catalogue) ? this.editForm.catalogue.join(',') : (this.editForm.catalogue || ''),
              explain: Array.isArray(this.editForm.explain) ? this.editForm.explain.join(',') : (this.editForm.explain || ''),
            }
            addOrEditOfferBook(data).then(response => {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.editVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            });
          }
        });
      },

    }
  }
</script>

<style lang="scss" scoped>
  .quotation-container {
    .tcf-row {
      .card {
        .card-body {
          .card-title {
            .add-btn {
              position: relative;
              float: right;
              margin-left: 10px;
              margin-top: -10px;
            }

            .search-mode {
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;

              .search-input {
                background-color: #F2F6FC;
                border: 0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;

                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }

                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }

              .search-btn {
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }

          .card-content {
            .group-filter {
              width: 100%;
              padding: 0 30px 0 0;
              margin: 0;
              position: relative;

              li {
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;

                &.active {
                  background: #f5f7fa;
                  color: #409EFF;
                }

                &:hover {
                  color: #409EFF;
                }
              }
            }

            .client-sex {
              width: 16px !important;
              height: 16px !important;
              vertical-align: -4px !important;
            }

            .el-table::before {
              height: 0 !important;
            }

            .el-pagination {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
